module.exports = __webpack_public_path__ + "static/media/technical-ico-grey.85150381.svg";